export interface GenericStatus<T> {
  icon?: string;
  value: T;
  displayName: string;
  helperText?: string;
  colorType: GenericStatusColorType;
}

export enum GenericStatusColorType {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  DEFAULT = 'default',
  DISABLED = 'disabled'
}
